export default __webpack_public_path__ + "static/media/no_transactions@3x.45d8c2eb.png";